import { get } from 'lodash';

/** Shift the product inputs up as needed to fill in any empty spots.
    @param productInputs Object with keys that when alphabetically sorted, are ordered sequentially.
      The presence of keys defines the total set of product inputs. Each keyed
      value may contain an object that represents an active or inactive
      (unspecified) product input.
    @return An object in same format at productInputs, but with elements shifted such that active
      product inputs are shifted to earlier keys that had previously contained inactive values. */
export const consolidateProductInputs = (productInputs) => {
  const writeProductInputs = {};
  const selectIds = Object.keys(productInputs).sort();
  let writeIndex = 0, readIndex = 0;
  while (readIndex < selectIds.length) {
    const productId = get(productInputs[selectIds[readIndex]], 'currentProductId');
    if (productId) { writeProductInputs[selectIds[writeIndex++]] = productInputs[selectIds[readIndex]]; }
    ++readIndex;
  }
  while (writeIndex < selectIds.length) { // Fill in any unwritten inputs with "inactive" values.
    writeProductInputs[selectIds[writeIndex++]] = { currentProductId:null };
  }
  return writeProductInputs;
};
